<template>
	<div>
		<wechat-header></wechat-header>
	</div>
</template>

<script>
	import WechatHeader from '@/pages/wechat/components/Header'
	export default {
		name: 'WechatHome',
		components: {
			WechatHeader
		}
	}
</script>

<style>
	@import '../../assets/css/reset.css'
	@import '../../assets/css/border.css'
</style>